// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1YlNw","header":"ReportDetails_header__2Umie","title":"ReportDetails_title__QqpD2","left":"ReportDetails_left__2FkfG"};